module.exports = __webpack_public_path__ + "img/image20.495d951c.png";